module.exports = __webpack_public_path__ + "img/no_wuliu.20b08ca5.png";